import { gql } from '@grandvisionhq/graphql';

const defaultPaymentResponse = gql`
  fragment DefaultPaymentResponseFragment on PlaceOrderMutationDefaultPaymentResponse {
    resultType
    pspReference
  }
`;
const emptyPaymentResponse = gql`
  fragment EmptyPaymentResponseFragment on PlaceOrderMutationEmptyPaymentResponse {
    resultType
  }
`;

export { defaultPaymentResponse, emptyPaymentResponse };
//# sourceMappingURL=default-payment-response.js.map
